module.exports = __webpack_public_path__ + "static/media/ic_info_outline_grey.13e34a6d.svg";